/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import truncate from 'lodash/truncate';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// app modules: props
import CollectionsProps from 'components/Collection/CollectionsProps';

function ShareMenuItem(props) {
  const {
    ItemComponent,
    Icon,
    value,
    label,
    secondary,
    heading,
    onClick,
    onComplete,
    shareImageUrl,
    textToShare,
    urlToShare,
    maxTextLength,
    iconClassName,
    ...others
  } = props;
  const baseUrl = useSelector(state => state.config.baseUrl);

  const handleClick = async () => {
    try {
      if (typeof onClick === 'function') {
        await onClick({
          title: heading,
          url: urlToShare?.startsWith('/') ? `${baseUrl}${urlToShare}` : urlToShare,
          text: truncate(textToShare, { length: maxTextLength, omission: '...' }),
          image: shareImageUrl?.startsWith('/') ? `${baseUrl}${shareImageUrl}` : shareImageUrl,
        });
      }
    } catch (err) {
      console.error('Failed to share: ', err);
      toast.error(`Failed to share`);
    }
    setTimeout(onComplete, 1000);
  };
  let icon = null;
  if (React.isValidElement(Icon)) {
    icon = Icon;
  } else if (Icon) {
    icon = <Icon fontSize="large" color="primary" />;
  }
  return (
    <ItemComponent key={value} value={value} onClick={handleClick} {...others}>
      {icon ? <ListItemIcon className={iconClassName}>{icon}</ListItemIcon> : null}
      <ListItemText secondary={secondary}>{label}</ListItemText>
    </ItemComponent>
  );
}

ShareMenuItem.propTypes = {
  collection: CollectionsProps.collection.isRequired,
  heading: PropTypes.string,
  Icon: PropTypes.elementType,
  iconClassName: PropTypes.string,
  ItemComponent: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  maxTextLength: PropTypes.number,
  onClick: PropTypes.func,
  onComplete: PropTypes.func,
  secondary: PropTypes.string,
  shareImageUrl: PropTypes.string,
  textToShare: PropTypes.string,
  urlToShare: PropTypes.string,
  value: PropTypes.string.isRequired,
};

ShareMenuItem.defaultProps = {
  heading: null,
  Icon: null,
  iconClassName: null,
  ItemComponent: 'div',
  maxTextLength: 1000,
  onClick: null,
  onComplete: () => {},
  secondary: null,
  shareImageUrl: null,
  textToShare: null,
  urlToShare: null,
};

export default ShareMenuItem;
